import LegacyTrackingService from "../tracking_service_legacy";

export default class TrackingService {

    constructor() {
        //fix npe if o tracking is not available
        this.global = window.o_global
        this.global = window.o_global || {};
        if (!this.global.eventQBus) {
            this.global.eventQBus = {
                emit: () => {
                }
            }
        }

        //fix npe if o tracking is not available
        this.util = window.o_util || {};
        if (!this.util.o_util) {
            this.util.o_util = {
                misc: {
                    getPagecluster: () => {}
                }
            }
        }

        // START: legacy tracking service should be removed when old tracking is obsolete
        // We have to include the old click tracking here, because we are not able to send separated click tracking events
        this.legacyTrackingServie = new LegacyTrackingService();
        // END
    }

    sendSmallShoppromoInitialViewTrackingEvent(featureOrder, featureIndex, personalizationContext, tiles, visibleTiles) {
        let trackingData = [this._createSmallShoppromoLabel(featureOrder, featureIndex, tiles.length, personalizationContext, "loaded")];
        [].map.call(tiles.slice(0, visibleTiles), tile => {
            tile.setIsTracked();
            trackingData.push(this._createSmallShoppromoTileLabel(tile.position, featureIndex, tile.dreson, tile.urlPath, tile.teslaModel, tile.imageId, tile.imageSelection, tile.variationId, "loaded"))
        });
        this.global.eventQBus.emit("tracking.bct.addFeaturesToPageImpression", trackingData);
    }

    sendSmallShoppromoClickTrackingEvent(featureOrder, featureIndex, personalizationContext, filledSlots, tile) {
        const featureTracking = [];
        featureTracking.push(this._createSmallShoppromoLabel(featureOrder, featureIndex, filledSlots, personalizationContext, "clicked"));
        featureTracking.push(this._createSmallShoppromoTileLabel(tile.position, featureIndex, tile.dreson, tile.urlPath, tile.teslaModel, tile.imageId, tile.imageSelection, tile.variationId, "clicked"));
        // START: remove legacy click tracking when old tracking is obsolete
        let labelTrackingData = this.legacyTrackingServie.getClickTrackingPayload("ShopPromotionSmall", tile.urlPath, featureOrder, featureIndex, filledSlots, tile.position, tile.teslaModel, "click", tile.dreson, personalizationContext);
        // END
        let pageCluster = window.o_util.misc.getPagecluster();
        labelTrackingData["wk.promo_AttributionFeature"] = `ShopPromotionSmall_${pageCluster}`;
        labelTrackingData["wk.promo_AttributionSource"] = tile.teslaModel;

        this.global.eventQBus.emit('tracking.bct.submitMoveAction', labelTrackingData, {
            name: "click",
            features: featureTracking
        });
        this.global.eventQBus.emit("tracking.bct.trackOnNextPageImpression", {"promo_Click": "ShopPromotionSmall"});
    }

    sendCinemaMovementTrackingEvent(featureOrder, featureIndex, filledSlots, personalizationContext, movementType) {
        this.global.eventQBus.emit('tracking.bct.submitAction', {}, {
            name: movementType,
            features: [this._createSmallShoppromoLabel(featureOrder, featureIndex, filledSlots, personalizationContext, "loaded")]
        });
    }

    sendViewTrackingEventForCinemaMovement(featureOrder, featureIndex, tiles, personalizationContext, startIndex, endIndex, movementType) {
        const featureTracking = [];
        [].map.call(tiles.slice(startIndex, endIndex + 1), tile => {
            if (!tile.isTracked()) {
                tile.setIsTracked();
                featureTracking.push(this._createSmallShoppromoTileLabel(tile.position, featureIndex, tile.dreson, tile.urlPath, tile.teslaModel, tile.imageId, tile.imageSelection, tile.variationId, "loaded"));
            }
        });

        if (featureTracking.length > 0) {
            featureTracking.push(this._createSmallShoppromoLabel(featureOrder, featureIndex, tiles.length, personalizationContext, "loaded"))
            this.global.eventQBus.emit('tracking.bct.submitAction', {}, {
                name: movementType,
                features: featureTracking
            });
        }
    }

    _createSmallShoppromoLabel(featureOrder, featureIndex, filledSlots, personalizationContext, status) {
        let labels = {};
        labels.promo_FeatureNumber = [featureIndex + 1];
        labels.promo_FilledSlots = [filledSlots];
        labels.promo_Feature = [true];
        personalizationContext ? labels.promo_Context = [personalizationContext] : null;

        return {
            id: 'ft3_spsnf' + featureIndex,
            name: "ShopPromotionSmall",
            position: featureOrder,
            status: status,
            labels: labels
        }
    }

    _createSmallShoppromoTileLabel(positionInSlider, featureIndex, dreson, urlPath, teslaModel, displayedImageId, imageSelection, variationIdOfImage, status) {
        let trackingPayload = {
            id: "ft3_spsnf" + featureIndex + "_tile" + positionInSlider,
            parentId: "ft3_spsnf" + featureIndex,
            name: "ShopPromotionSmall-Tile",
            position: positionInSlider,
            status: status,
            labels: {
                promo_Content: [urlPath],
                promo_TargetPsr: [dreson],
                promo_Source: [teslaModel],
                promo_ImageId: [displayedImageId],
                promo_ImageSelection: [imageSelection]
            }
        };

        if (variationIdOfImage) {
            trackingPayload.variationId = variationIdOfImage;
        }

        return trackingPayload
    }

}
